import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import "../../css/course-page.css";


class Signalprocessingusingmatlab extends Component {
    render() {
        return (
             <div>
                    <div aria-label="breadcrumb">
                         
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                                <li class="breadcrumb-item active">Signal Processing using MATLAB</li>
                            </ol>
                        </div>
                        <section class="course-header bg-blue1" id="course-header">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                                    <h1>Signal Processing using MATLAB</h1>
                                    <p>A Comprehensive Guide to Digital Signal Processing</p>
                                    <br /> <br /> 
                                    <div class="row">
                                    <button class="pulse-button" type="button" data-toggle="modal" onclick="startvideo()" data-target="#myModalq"></button>
                                        <p class="Watch-Intro">Watch Intro Video </p>
                                    </div>
                                    <br />
                                    <div class="form-group">
                                    <a href="#apply-now" class="btn btn-md enroll-btn">Enroll Now </a>

                                      
                                        <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                            data-target="#myModal"  >Download
                                            brochure</button> <br />  <br /> <br /> 
                                        </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1"></div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                
                                    <p>Jointly Delivered by </p>
                                    <ul>
                                        <li><img width="" src="/assets/images/epn.svg" alt ="" /></li>
                                        <li >Rupali Tornekar</li>
                                    </ul>
                                    <br />
                                </div>
                            </div>
                        </section>
                        <div class="course-main-contains def-z" id="Description">
                            <div class="card">
                                <div class="row contanint-display">
                                    <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                                    <b>What's included : <br />
                                    <i class="fa fa-mobile" ></i> &nbsp;&nbsp;Mobile Support</b>  
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                                    <b><i class="fa fa-comments" ></i> &nbsp; Discussion Forum</b><br />
                                    <b><i class="fa fa-certificate" ></i> &nbsp; Course Certificate</b>
                                    </div>
                                    <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4" >    
                                    <b><i class="fa fa-question" ></i> &nbsp;&nbsp;&nbsp;Quiz</b><br />
                                    <b><span class="gold"></span> Online Compiler</b>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <section class="def-z">
                             <div class="header" id="myHeader">
                                <ul>
                                    <li><a href="#Description">Description</a></li>
                                    <li><a href="#Eligibility">Eligibility</a></li>
                                    <li><a href="#Tools">Tools</a></li>
                                    <li><a href="#Syllabus">Syllabus</a></li>            
                                    <li><a href="#Outcomes">Learning Outcomes</a></li>           
                                    <li><a href="#Reviews">Learner Review </a></li>          
                                    <li><a href="#Instructor">About Instructor</a></li> 
                                    <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>            
                                </ul>
                            </div>
                        </section>
                        <section class="course-description" id="course-description">
                            <br />
                            <div class="row"  id="Eligibility">
                                <div class="col-sm-12">
                                    <h3 >Description</h3>
                                    <p align="justify">This online course is designed by an expert from Vishwakarma institute of Technology Pune. This Course emphasizes on Theory concepts as well as Hands on sessions of Signal processing algorithms implemented using MATLAB platform.
                                    It is very useful course for research scholars, Faculty and Students working in signal Processing Area. This course also focuses on project ideas and its implementation using MATLAB GUI.
                                    It is a perfect blended course which comprises Theory as well as Hands on sessions.In totality this course focuses on development of customized functions using MATLAB platform.</p>
                                </div>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col-sm-12">
                                    <h3  class="heading-tab">Who Should Enroll?</h3>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <ul class="highlight-ul" >
                                        <li>Budding Engineerings who wants to make their carrier in Signal processing</li>
                                        <li>Industry professionals who are interested in online Signal Processing Course with Algorithm implementation in MATLAB platform</li>
                                    </ul>
                                </div>
                                <div class="col-sm-6" id="Tools">
                                    <ul class="highlight-ul">
                                        <li>UG/PG/Diploma/Ph.D scholars who are looking for training in Signal procesing algorithm implementation using MATLAB</li>
                                        <li>Teachers who are interested in Signal Processing Algorithms implementation using MATLAB</li>
                                    </ul>
                                </div>
                            </div>
                            <h2> Tools Covered</h2><br />
                             <div class="row">
                                <div class="col-md-3 col-sm-12">
                                    <div class="card cards-singles">
                                    <center id="Syllabus">
                                        <img src="/assets/images/icons/matlab-logo.png" alt=""/> </center>
                                        </div>
                                </div>
                            </div>
                        </section>


                        <section class="course-syllabus" id="course-syllabus">
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10" >
                                    <h3> Syllabus </h3>
                                    <br />
                                    <div class="syl-bg">
                                       
                                        <div id="de_syllabus">
                                            <div class="panel-group">
                                                <div class="panel panel-info">
                                                <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                                    href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                                    <h6 class="panel-title">
                                                        <i class="indicator fa fa-minus"></i> Introduction to Signal Processing 
                                                    </h6>
                                                </div>
                                                <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                                    data-parent="#de_syllabus">
                                                    <div class="panel-body">
                                                        <ul class="syllabus-ul">
                                                            <li> Introduction to Signals Processing course</li>
                                                            <li> what is signal processing </li>
                                                            <li> Dimentionality of Signals </li>
                                                            <li> Types of Signals- Analog Vs Digital</li>
                                                            <li> Dimentionality of Signals </li>
                                                            <li> Introduction to MATLAB</li>
                                                            <li> 1D Matrix Algebra </li>
                                                            <li> 2D Matrix Algebra using MATLAB </li>
                                                            <li> plotting of waveforms </li>
                                                            <li> creation of user defined functions </li>
                                                            <li> Standard Test signals </li>
                                                            <li> Types of Signals_Energy & Power </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                </div>
                                                
                                                <div class="panel panel-info">
                                                <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                                    href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                                    <h6 class="panel-title">
                                                        <i class="indicator fa fa-minus"></i> 1D Signal Processing
                                                    </h6>
                                                </div>
                                                <div id="de_syllabus2" class="collapse " aria-labelledby="de_heading2"
                                                    data-parent="#de_syllabus">
                                                    <div class="panel-body">
                                                        <ul class="syllabus-ul">
                                                            <li> Convolution_Output of LTI System</li>
                                                            <li> Correlation of two Signals</li>
                                                            <li> Need of Fourier Transform</li>
                                                            <li> Fourier Transform of Standard Signals</li>
                                                            <li> Implement Fourier Transform of a signal using MATLAB</li>
                                                            <li> Implement verification of sampling theorem</li>
                                                            <li> Laplace Transform</li>
                                                            <li> Implement Laplace Transform</li>
                                                            <li> System Response with respect to pole zero locations</li>
                                                            <li> Implement 1D FIR Filtering using MATLAB</li>
                                                            <li> Notch Filter Design</li>
                                                            <li> Implement Notch Filter</li>
                                                            <li> Discrete Cosine Transform</li>
                                                            <li> Implement 1D Discrete Cosine Transform_create user defined function</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                </div>
                                               
                                                <div class="panel panel-info">
                                                <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                                    href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                                    <h6 class="panel-title">
                                                       <i class="indicator fa fa-minus"></i> 2d Signal Processing
                                                    </h6>
                                                </div>
                                                <div id="de_syllabus3" class="collapse " aria-labelledby="de_heading3"
                                                    data-parent="#de_syllabus">
                                                    <div class="panel-body">
                                                        <ul class="syllabus-ul">
                                                            <li> Image Types</li>
                                                            <li> Implement Image Preprocessing-Binarization, Negation</li>
                                                            <li> Image enhancement</li>
                                                            <li>  Image Low Pass Filtering</li>
                                                            <li> Implement Image Low Pass Filtering using MATLAB</li>
                                                            <li>  Image High Pass Filtering</li>
                                                            <li>  Implement Image High Pass Filtering using MATLAB</li>
                                                            <li>  Median Filtering</li>
                                                            <li> Implement Median Filtering on Image using MATLAB</li>
                                                            <li> Bit plane slicing</li>
                                                            <li> Implement Bit Plane Slicing on Image using MATLAB</li>
                                                            <li>  Implement Morphological Operations</li>
                                                            <li>  Implement 2D Fourier Transform and 2D Discrete Cosine Transform (DCT) using MATLAB</li>
                                                            <li> Wavelet Transform</li>
                                                            <li> Implement 1D Wavelet Transform</li>
                                                            <li> Implement 2D Wavelet Decomposition</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                </div>
                                               
                                                <div class="panel panel-info">
                                                <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                                    href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                                    <h6 class="panel-title">
                                                        <i class="indicator fa fa-minus"  id="Outcomes"></i> GUI Creation 
                                                    </h6>
                                                </div>
                                                <div id="de_syllabus4" class="collapse " aria-labelledby="de_heading4"
                                                    data-parent="#de_syllabus">
                                                    <div class="panel-body">
                                                        <ul class="syllabus-ul">
                                                            <li > GUI Creation using MATLAB</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                </div>
                                               
                                                <div class="panel panel-info">
                                                <div class="panel-heading" id="dv_heading2" data-toggle="collapse"
                                                    href="#dv_syllabus2" aria-expanded="true" aria-controls="dv_syllabus2">
                                                    <h6 class="panel-title" >
                                                        <i class="indicator fa fa-minus"></i> Project Implementation
                                                    </h6>
                                                </div>
                                                <div id="dv_syllabus2" class="collapse " aria-labelledby="dv_heading2"
                                                    data-parent="#dv_syllabus">
                                                    <div class="panel-body">
                                                        <ul class="syllabus-ul">
                                                            <li>Project1_Image Quantization using GUI of MATLAB</li>
                                                            <li >Project2_Music Signal Processing</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                </div>
                                               
                                            </div>
                                          
                                        </div>
                                    </div>
                                    </div> 
                            </div>
                        </section> 

                        <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                            <div class="row">
                                <div class="col-sm-6">
                                    <h3>Learning Outcomes</h3>
                                    <ul class="lo-ul">
                                        <li>To understand different signal Processing concepts and Algorithms</li>
                                        <li>To implement signal processing algorithms using MATLAB platform</li>
                                        <li>To create user defined functions using MATLAB</li>
                                        <li>To process 1D and 2D data from preprocessing to feature extraction</li>
                                        <li>Improvement in Programming skills</li>
                                    </ul>
                                    <br />
                                    <h3>Assessment</h3>
                                    <div class="table-responsive course-batch-schedule"> 
                                        <div class="card">
                                            <table class="table">
                                                <thead>
                                                    <tr class="text-center">
                                                <th >Type</th>
                                                <th >Weightage %</th>
                                            </tr>
                                        </thead>
                                        <tbody class="content-size">
                                        <tr >
                                                <td >Assignment</td>
                                                <td >50%</td>
                                            </tr>
                                            <tr>
                                                <td >Content</td>
                                                <td id="Reviews">50%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                </div>
                                </div>
                                <div class="col-sm-6">
                                    <img src="/assets/images/icons/certificate1.png" alt=""/>

                                </div>
                            </div>
                            <br /><br />
                        </section> 
                        <section class="course-admission-process"> 
                     
                         </section>
                         <Aboutuslearners />     
  <Aluminicompany />

                        <section class="courses-feesm">
                           <section class="course-fees" id="course-fees">
                           <div class="row box-sh" >
                                 <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                                   
                                </div>
                                <div class="vertical-line-fee"> </div>
                                <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                    <div class="row">
                                        <div class="col-sm-10"> <br /><br />
                                            <h5>Features</h5>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12">
                                        <ul class="highlight-ss" >
                                        <li>Course focuses on project ideas.</li>
                                        <li> Implementation using MATLAB GUI.</li>
                                        <li> Perfect blend of theory as well as Hands-on.</li>
                                        <li> Signal Processing Algorithms Implementation Using MATLAB.</li>
                                        </ul>
                                        </div>
                                        <p>{// eslint-disable-next-line
                                        } <marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 " > &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                                                </p>  
                                    </div>
                                </div>
                            </div>
                        </section> 
                        </section> 
                        <Whyedu/>
                        <section class="course-about-instructor bg-secondary " id="course-about-instructor" >
                           <div class="row">
                                <div class="col-sm-12">
                                    <h3>
                                    About the Instructor
                                    </h3>
                                    <br />
                                    <div class="about-ist">
                                        <div class="card pd-abt-ist">
                                            <div class="social-instructor">
                                            <img  onerror="this.onerror=null;this.src='https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg';" alt="" src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/19_0.jpg" />
                                            </div>
                                            <div class="inst-details">
                                            <h3>Rupali Tornekar</h3>
                                                <p>12 Years Of Experience</p>
                                                <br />
                                                <h4>Vishwakarma Institute of Technology, Pune</h4>
                                                <p align="justify">I am Prof. Rupali Tornekar(Gavaraskar), working as Asst. Prof. in Department of Electronics Engineering, Vishwakarma Institute of Technology, Pune.</p>
                                            <br />
                                            <ul class="course-about-ul">
                                            <li>{// eslint-disable-next-line
                                                }<a href="#" >
                                                <i class="fa fa-facebook" target="_blank"></i>
                                            </a>
                                            </li>
                                            <li >{// eslint-disable-next-line
                                                }<a href="https://www.linkedin.com/in/rupali-tornekar-969048110/" target="_blank"  >
                                                                    <i class="fa fa-linkedin" ></i>
                                                                </a>
                                                            </li>
                                                            <li >{// eslint-disable-next-line
                                                }<a href="#" >
                                                                    <i class="fa fa-twitter" target="_blank"></i>
                                                                </a>
                                                            </li>
                                                            <li >{// eslint-disable-next-line
                                                }<a href="#"  target=""><i class="fa fa-instagram" target="_blank"></i></a></li>
                                                </ul>
                                                </div>
                                       </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                       
                        <div class="modal fade" id="myModalq" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div class="modal-dialog  modal-xl" role="document">
                                <div class="modal-content">
                                    <div class="modal-body">
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" onclick="stopvideo()">
                                        <span class="colse-icon" aria-hidden="true">&times;</span>
                                        </button>        
                                       
                                        <div class="embed-responsive embed-responsive-21by9">
                                        <video controls="true" class="embed-responsive-item"  id="video">
                                            <source src="https://s3.ap-south-1.amazonaws.com/eduplusnowlive1/course/28/23/video/Introduction.mp4" type="video/mp4" />
                                        </video>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>


                            <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">
                                        <div class="modal-header" >
                                            <span class="close" id="close_form"
                                            data-dismiss="modal">&times;</span>
                                        <br />
                                        </div>
                                        <div class="modal-body" >
                                            <div class="panel panel-default paper-shadow box_detail" >
                                                <h5 class="text-center "> Download The Course Brochure </h5>
                                                <form method="post" class="form-row"  onsubmit="return validate()">

                                                    <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                                        required="" autocomplete="on" name="name" id="name" />
                                                    <b>Your email</b><input class="form-control" type="email" required=""
                                                        autocomplete="on" name="emaill" id="emaill" />
                                                    <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                                        type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                                    <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />     
                                                    <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                                    <br />
                                                    <div>
                                         <div class="form-group">
                                         <div  id="recaptcha" class="g-recaptcha"
                                             data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                             <div id="captcha"></div>
                                         </div>
                                     </div>
                                     
                                     <div class="mob_cb" >

                                         <div>
                                         </div><br />
                                       
                                          <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button>
                                          </div>
                                          <br />
                                 </form>
                             </div>
                         </div>
                     </div>

                 </div>

             </div>
            </div>

           
        );
    }
}

export default Signalprocessingusingmatlab;
